import moment from 'moment'
import getCurrentWeekWithStartDateOnThursday from './getCurrentWeekWithStartDateOnThursday'

// Cinema weeks run Thursday–Wednesday, which doesn't align with ISO (Monday–Sunday)
// weeks. Anchoring to the most recent Thursday first keeps Mon/Tue/Wed from being
// mislabeled as the following cinema week.
const getCurrentCinemaWeeksArray = () => {
    const anchor = moment(getCurrentWeekWithStartDateOnThursday())
    const weeksArray = []

    for (let i = 0; i < 3; i++) {
        const anchorClone = anchor.clone()
        const week = 0 === i ? anchorClone.subtract(1, 'weeks') : anchorClone.add(i - 1, 'weeks')

        weeksArray.push({
            isoWeek: week.isoWeek(),
            year: week.day('thursday').year()
        })
    }

    return weeksArray
}

export default getCurrentCinemaWeeksArray
